import { useEffect, useState } from 'react';
import { cxcRegistrationAPI } from '../services/api';
import { CxcOptions } from '../types';
import { Logger } from '../utils/logger';

// The CXC sittings, deadlines and fees, fetched once and shared by every
// screen that shows them (menus, dashboard banner, header, the form). The
// server decides what is open, in Cayman time - the app parses no dates.

let pending: Promise<CxcOptions> | null = null;

export function loadCxcOptions(): Promise<CxcOptions> {
  if (!pending) {
    pending = cxcRegistrationAPI.getOptions()
      .then(res => res.data)
      .catch(err => {
        pending = null; // try again next time something asks
        throw err;
      });
  }
  return pending;
}

/** Null until the server answers; the CXC entry points stay hidden until then. */
export function useCxcOptions(): { options: CxcOptions | null; error: boolean } {
  const [options, setOptions] = useState<CxcOptions | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    loadCxcOptions()
      .then(o => { if (!cancelled) setOptions(o); })
      .catch(err => {
        Logger.error('CxcOptions', 'Failed to load the CXC sittings and fees', err);
        if (!cancelled) setError(true);
      });
    return () => { cancelled = true; };
  }, []);

  return { options, error };
}
